// Planner Project Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'

import IconButton from '../../common/icon_button/icon_button.jsx'
import DateUtil from '../../../lib/dateutil.jsx'
import PlannerDateRange from '../planner_daterange/planner_daterange.jsx'
import PlannerKanBanItem from '../planner_kanbanitem/planner_kanbanitem.jsx'

class PlannerProject extends Component {
  static get propTypes () {
    return {
      project: PropTypes.object,
      viewMode: PropTypes.string,
      isExpand: PropTypes.bool,
      showExpand: PropTypes.bool,
      onToggleExpand: PropTypes.func
    }
  }

  static get defaultProps () {
    return {
      project: null,
      viewMode: '',
      isExpand: false,
      showExpand: true,
      onToggleExpand: null
    }
  }

  shouldComponentUpdate (nextProps, _nextState) {
    const { project, viewMode, isExpand, showExpand } = this.props
    if (
      !_.isEqual(project, nextProps.project) ||
      viewMode !== nextProps.viewMode ||
      isExpand !== nextProps.isExpand ||
      showExpand !== nextProps.showExpand
    ) {
      return true
    }
    return false
  }

  render () {
    const { project, viewMode, isExpand, showExpand } = this.props
    const kanbanInfo = project.kanbanInfo || {}

    return (
      <div className='planner-project'>
        <div className='titleinfo'>
          <div className='actioncont'>
            {showExpand && (
              <IconButton
                icon={isExpand ? 'arrow-up' : 'arrow-down'}
                iconSize='12'
                className='actionexpand'
                canHover
                onClick={this._onToggleExpand.bind(this, !isExpand, project.id)}
              />
            )}
          </div>
          <div className='imagecont'>
            <IconButton icon='projects' size='big' hasBorder canHover />
          </div>
          <div className='titlecont'>
            <div className='title'>{project.title}</div>
            {(project.startDate || project.endDate) && (
              <div className='subtitle'>
                {project.startDate
                  ? DateUtil.getDisplayDate(project.startDate)
                  : ''}
                {project.endDate
                  ? ' - ' + DateUtil.getDisplayDate(project.endDate)
                  : ''}
              </div>
            )}
          </div>
        </div>
        <div className='dateinfo'>
          {viewMode === 'kanban' ? (
            <>
              <PlannerKanBanItem
                key='todo'
                type='todo'
                title='plannerv2.planner.taskInfoTitleTodo'
                count={kanbanInfo.countTodo}
              />
              <PlannerKanBanItem
                key='inprogress'
                type='inprogress'
                title='plannerv2.planner.taskInfoTitleInProgress'
                count={kanbanInfo.countInProgress}
              />
              <PlannerKanBanItem
                key='completed'
                type='completed'
                title='plannerv2.planner.taskInfoTitleDone'
                count={kanbanInfo.countCompleted}
              />
            </>
          ) : (
            <PlannerDateRange
              items={project.dayItems}
              isWeekMode={viewMode === 'week'}
              showMarker={!!(project.startDate && project.endDate)}
              showGanttBar
            />
          )}
        </div>
        <div className='actioninfo' />
      </div>
    )
  }

  _onToggleExpand (isExpand, projectId) {
    const { onToggleExpand } = this.props

    if (onToggleExpand) {
      onToggleExpand(isExpand, projectId)
    }
  }
}

export default PlannerProject
